module.exports = __webpack_public_path__ + "img/no-data-logs-light.4810930b.svg";